import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column } from '@nirvana/shared/dtos/types/shared/filters';
import {
  GetRowsRequest,
  SetFiltersRequest,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { ColumnKeys, BreachPathNode } from '../types';

export class BreachPathDetailsGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  dependencies;
  data;

  constructor(dependencies, data: BreachPathNode[]) {
    super();
    this.dependencies = dependencies;
    this.data = data;
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<any> {
    return { rawEvents: this.data ?? [] };
  }

  async updateSettings(params: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    return {};
  }
}
